import { z } from 'zod'

export const LoginSchema = z.object({
  email: z.string().email(),
  password: z.string().min(8),
})

export const TenantSelectSchema = z.object({
  tenantSlug: z.string().min(1),
})

export type LoginInput = z.infer<typeof LoginSchema>
export type TenantSelectInput = z.infer<typeof TenantSelectSchema>

// ─── Tenant Auth Config (public endpoint response) ──────

export const TenantAuthConfigResponseSchema = z.object({
  id: z.string(),
  slug: z.string(),
  name: z.string(),
  authProvider: z.string(),
  authConfig: z.record(z.string(), z.string().optional()),
})

export type TenantAuthConfigResponse = z.infer<typeof TenantAuthConfigResponseSchema>
